export default {
  'comparison_analysis_title': "Comparison Analysis",

  'comparison_analysis_country_comparison_title': "Country Comparison",

  'comparison_analysis_country_comparison_key_global': "Global",

  'comparison_analysis_country_comparison_key_total': "Total",

  'comparison_analysis_country_comparison_key_metrics_ranking': "Key Metrics Ranking",

}
